import { User } from '@spo/logic';
import { WelcomeLogo } from '@spo/storybook';
import { useTranslation } from 'react-i18next';
import { UserButton } from '../user/UserButton';
import './welcome.scss';

export type WelcomeProps = {
  user?: User;
};

export const Welcome = ({ user }: WelcomeProps) => {
  const { t } = useTranslation();

  return user ? (
    <>
      <div data-testid="welcome" className="welcome">
        <h2 className="welcome-title">{t('stepper.welcome_msg')}</h2>
        <WelcomeLogo />
      </div>
      <UserButton user={user} />
      <div>
        <span className="spo-description">{t('spo_description')}</span>
      </div>
    </>
  ) : null;
};
